import React from "react";
import { RowData } from "@tanstack/react-table";
import { cn } from "utils";
import { BaseTable } from "../TanStackTable/BaseTable";
import type {
  TanStackTableProps,
  TableClassNames,
} from "../TanStackTable/types";

const defaultClassNames: TableClassNames = {
  container:
    "w-full overflow-hidden rounded-1 relative border border-border_solid",
  scrollContainer: "overflow-x-auto relative [&::-webkit-scrollbar]:w-0",
  table: "w-full border-separate",
  thead: "sticky top-0 z-[5] bg-background_solid_tertiary",
  th: "p-2 text-left body_medium_s text-content_secondary border-b border-r border-border_white_transparent10 last:border-r-0 bg-background_solid_tertiary",
  thPinned: "sticky z-[6]",
  tbody: "",
  tr: "cursor-pointer",
  td: "px-2 py-1.5 text-sm text-content_primary border-b border-r border-border_solid last:border-r-0 body_medium_m",
  tdPinned: "sticky bg-background_solid_tertiary",
};

export function StockDetailTable<T extends RowData>({
  data,
  columns,
  enableRowPinning = false,
  rowPinning,
  keepPinnedRows = true,
  maxHeight,
  headerHeight = 40,
  rowHeight = 40,
  className,
  classNames,
  getRowId,
  onRowClick,
  rowClassName,
}: TanStackTableProps<T>) {
  const mergedClassNames: TableClassNames = {
    container: cn(
      defaultClassNames.container,
      classNames?.container,
      className,
    ),
    scrollContainer: cn(
      defaultClassNames.scrollContainer,
      classNames?.scrollContainer,
    ),
    table: cn(defaultClassNames.table, classNames?.table),
    thead: cn(defaultClassNames.thead, classNames?.thead),
    th: cn(defaultClassNames.th, classNames?.th),
    thPinned: cn(defaultClassNames.thPinned, classNames?.thPinned),
    tbody: cn(defaultClassNames.tbody, classNames?.tbody),
    tr: cn(defaultClassNames.tr, classNames?.tr),
    trPinned: cn(defaultClassNames.trPinned, classNames?.trPinned),
    td: cn(defaultClassNames.td, classNames?.td),
    tdPinned: cn(defaultClassNames.tdPinned, classNames?.tdPinned),
  };

  return (
    <div data-horizontal-scroll="true">
      <BaseTable
        data={data}
        columns={columns}
        enableRowPinning={enableRowPinning}
        rowPinning={rowPinning}
        keepPinnedRows={keepPinnedRows}
        maxHeight={maxHeight}
        headerHeight={headerHeight}
        rowHeight={rowHeight}
        classNames={mergedClassNames}
        getRowId={getRowId}
        onRowClick={onRowClick}
        rowClassName={rowClassName}
      />
    </div>
  );
}
